import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import * as option from "@/models/configurator/configurator_options";

import { CanopyState } from "./types";

const state = {
  mainCanopy: option.Panel.Solid,
  mainFabric: [],
  undersideFabric: null,
  mainTrimFabric: null,
  mainTrimFabricInner: null,
  ventTopFabric: [],
  ventMiddle: null,
  ventMiddleFabric: [],
  ventTrimFabric: null,
  valance: option.Valance.Canopy,
  valanceFabric: [],
  bindingFabric: null,
  rib: null,
  ribFabric: null,
  fringe: option.Fringe.None,
  fringeFabric: []
} as unknown as CanopyState;

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
